import type { AppLocale } from './locale'
import { translations } from './translations'

export type TranslationParams = Record<string, string | number | null | undefined>

export const resolveKey = (locale: AppLocale, key: string): string => {
    const segments = key.split('.')
    let value: unknown = translations[locale]

    for (const segment of segments) {
        if (!value || typeof value !== 'object' || !(segment in value)) {
            return key
        }
        value = (value as Record<string, unknown>)[segment]
    }

    return typeof value === 'string' ? value : key
}

export const interpolate = (template: string, params?: TranslationParams): string => {
    if (!params) {
        return template
    }

    return template.replace(/\{\{(\w+)\}\}/g, (_match, paramName: string) => {
        const value = params[paramName]
        return value == null ? '' : String(value)
    })
}

/** Non-hook translation for code outside React (e.g. the API client). */
export const translate = (locale: AppLocale, key: string, params?: TranslationParams): string =>
    interpolate(resolveKey(locale, key), params)
